<template>
	<div class="banner">
		<swiper ref="mySwiper" :options="swiperOption">
			<swiper-slide
				v-for="(item, index) in slide"
				:key="index"
				class="swiper-slide"
				:style="{
					height: height,
					background:
						'url(' + item.srcFileName + ') center no-repeat',
				}"
				@click.native="goto(item.url)"
			>
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
	</div>
</template>
<script>
export default {
	props: {
		height: {
			type: String,
			default: '33rem',
		},
	},
	name: 'App',
	computed: {
		// 获取swiper实例
		swiper() {
			return this.$refs.mySwiper.$swiper
		},
	},
	data() {
		return {
			slide: [],
			//设置属性
			swiperOption: {
				//显示分页
				pagination: {
					el: '.swiper-pagination',
					clickable: true, //允许分页点击跳转
				},
				//自动轮播
				autoplay: {
					delay: 5000,
				},
				effect: 'fade',
				//开启循环模式
				loop: false,
				allowTouchMove: false,
				//开启鼠标滚轮控制Swiper切换
				mousewheel: false,
			},
		}
	},
	watch: {
		$route: {
			handler: function(val) {
				this.initType(val.path.split('/')[1])
			},
		},
	},
	created() {
        // console.log('监听轮播图路由create',this.$route.path.split('/')[1])
        // this.getBanner(1)
		this.initType(this.$route.path.split('/')[1])
	},

	updated() {
		// console.log(this.swiper.pagination.bullets.length)
		for (let i = 0; i < this.swiper.pagination.bullets.length; i++) {
			this.swiper.pagination.bullets[i].onmouseover = function() {
				this.click()
			}
		}
	},
	methods: {
		goto(path){
			// console.log('点了banner啊啊啊啊啊》》》》》》》》》》》》》》》》》》',path)
			if(path){
				window.location.href = path
			}
		},
		initType(type) {
			switch (type) {
				case 'index':
					this.getBanner(1)
					break
				case 'laureates':
					this.getBanner(2)
					break
				case 'nomination':
					this.getBanner(3)
					break
				case 'donors':
					this.getBanner(4)
					break
				case 'news':
					this.getBanner(5)
					break
				case 'activity':
					this.getBanner(6)
					break
				case 'about':
					this.getBanner(7)
                    break
                default:
                    this.getBanner(1)
			}
		},
		getBanner(type) {
			this.$forumApi.bannerList().then((res) => {
				this.slide = res.data
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.swiper-slide {
	width: 100%;
	background-size: 150% 100% !important;
}

.banner::v-deep {
	.swiper-pagination-bullet {
		opacity: 1;
	}
	.swiper-pagination-bullet {
		background-color: #fff;
	}
	.swiper-pagination-bullet.swiper-pagination-bullet-active {
		background: $science-theme-color;
	}
	.swiper-pagination-bullet {
		width: 0.93rem;
		height: 0.93rem;
	}
}

@media (max-width: 992px) {
	.swiper-slide {
		height: 14rem !important;
		background-size: 100% 100% !important;
	}
}

</style>
